<template>
    <sys-register-base 
        :loading="loading" 
        @onSave="save" 
        :model.sync="model" 
        :title="title" 
        icon="mdi-book-plus-multiple" 
        v-bind:show.sync="dialog"
        maxWidth="40%"
    >
        <template v-slot:form>
            <v-container>
                    <v-row>
                       
                        <v-col cols="12" sm="9">
                            <v-text-field autofocus :error="!!errors.name" :error-messages="errors.name" v-model="model.name" label="Nome*"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="3">
                            <s-text-field code :error-messages="errors.code" v-model="model.code" label="Código"/>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="6">
                            <sys-select-occurrence-nature
                                :model.sync="model.occurrence_nature_id"
                                :error="errors.length > 0"  
                                :errors="errors.occurrence_nature_id"
                                label="Natureza da Ocorrência*"
                            />
                        </v-col>
                        <v-col  cols="12" sm="6">
                            <sys-select-occurrence-status
                                :model.sync="model.occurrence_status_id"
                                :error="errors.length > 0"  
                                :errors="errors.occurrence_status_id"
                                label="Status Padrão"
                                 clearable
                                 :natureId="model.occurrence_nature_id"
                            />
                        </v-col>
                    </v-row>
                    <v-row>

                        <v-col cols="12" sm="6">
                            <sys-select-occurrence-absence
                                :model.sync="model.occurrence_absence_id"
                                :error="errors.length > 0"  
                                :errors="errors.occurrence_absence_id"
                                label="Ausência/Banco de Horas"
                                clearable
                            />
                        </v-col>

                       <v-col cols="12" sm="6">
                             <sys-select-occurrence-sheet-type
                                :model.sync="model.occurrence_record_type_id"
                                :error="errors.length > 0"  
                                :errors="errors.occurrence_record_type_id"
                                label="Tipo de Registro"
                                clearable
                            />
                        </v-col>

                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="12">
                            <v-textarea
                                :error-messages="errors.description" 
                                v-model="model.description" 
                                label="Descrição"
                                :counter="255"
                                :rules="[v => (!v || v.length <= 255) || 'Máximo de 255 caracteres atingido']"
                                outlined
                                 />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="12">
                            <s-text-field :error-messages="errors.link" v-model="model.link" label="Link" clearable />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="6">
                            <v-switch inset v-model="model.allow_editing" label="Permitir Validação"></v-switch>
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-switch inset v-model="model.requires_certificate" label="Requer atestado"></v-switch>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="6">
                            <s-switch inset text-helper="Evento utilizado para incluir uma nova ocorrência" v-model="model.is_additional" label="Adicional" />
                        </v-col>
                         <v-col cols="12" sm="6">
                            <s-switch inset text-helper="Evento utilizado informação de feriado" v-model="model.is_holiday" label="Feriado" />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="6">
                            <s-switch inset text-helper="Ocorrência automática para os registros pré-assinalados" v-model="model.pre_marked" label="Pré-Assinalada" />
                        </v-col>
                        <v-col cols="12" sm="6">
                            <s-switch inset text-helper="Requer informar o motivo ao registrar a ocorrência" v-model="model.requires_motive" label="Motivo Obrigatório" />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="6">
                            <v-switch inset v-model="model.active" label="Ativo"></v-switch>
                        </v-col>
                    </v-row>
            </v-container>
            <!-- Alert para mensagens -->
            <emc-alert-snackbar :show="!! message.length"  :message="message" :color="error ? 'error' : 'success'"/>
        </template>
    </sys-register-base>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
    name: "SysOccurrenceTypeRegister",
    data: (vm) => ({
        dialog: false,
        error: false,
        errors: {},
        message: '',
        loading: false,
    }),
    created(){
       
    },

    computed: {
      ...mapState('auth', ['acesso']),
    },

    watch: {
        
        dialog(dialog_new, dialog_old) {
            
            if(dialog_new !== dialog_old) {
                this.$emit('update:show', dialog_new)
            }

        },

        show(show_new, show_old) {
            
            this.dialog = show_new;
            
            if(show_new){
                this.error = false;
                this.errors = {};
                
                if(!this.model.id){
                    this.model.active = 1;
                    this.model.allow_editing = 1;
                }

            }
        },
        
    },
    props: {
        model: {
            default: null
        },
        color: {
            type: String,
            default: 'grey lighten-5'
        },
        width: {
            type: String,
            default: "500"
        },
        maxWidth: {
            type: String,
            default: "80%"
        },
        icon: {
            type: String,
            default: "mdi-alert"
        },
        title: {
            type: String,
            default: "Tipo de Ocorrência"
        },
        text: {
            type: String,
            default: ""
        },
        show: {
            type: Boolean,
            default: false
        }
    },
    methods:{
        ...mapActions('timeSheet', ['ActionUpdateOccurrenceType', 'ActionCreateOccurrenceType']),

        save(edit)
        {
            this.error = false;
            this.message = '';
            this.loading = true;

            Object.assign(this.model, {institution_id: this.acesso.instituicao.id})

            if(edit) {
                this.ActionUpdateOccurrenceType(this.model)
                .then((res) => {
                    this.message = res.message;
                    this.$emit('onCompleted');
                })
                .catch((error) =>{
                    this.error      = true;
                    this.errors     = error.errors;
                    this.message    = error.message;
                })
                .finally(() => {
                     this.loading = false;
                })
            } else {
                this.ActionCreateOccurrenceType(this.model)
                .then((res) => {
                    this.message = res.message;
                    this.$emit('onCompleted', res.data);
                })
                .catch((error) =>{
                    this.error      = error;
                    this.errors     = error.errors;
                    this.message    = error.message;
                })
                .finally(() => {
                   this.loading = false;
                })

            }
        },

    }
}
</script>